var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPa = function SvgPa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f15e32f6-abc2-415e-9efd-bb8b8863de94a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cca76731-871c-4846-8b9c-5673e9aee673b",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cca76731-871c-4846-8b9c-5673e9aee673b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005095",
    fillRule: "evenodd",
    d: "M5.974 4.974C5.908 5.57 5.72 6 5.5 6s-.408-.43-.474-1.026C4.43 4.908 4 4.72 4 4.5s.43-.408 1.026-.474C5.092 3.43 5.28 3 5.5 3s.408.43.474 1.026C6.57 4.092 7 4.28 7 4.5s-.43.408-1.026.474",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4062E",
    fillRule: "evenodd",
    d: "M15.974 11.974C15.908 12.57 15.72 13 15.5 13s-.408-.43-.474-1.026C14.43 11.908 14 11.72 14 11.5s.43-.408 1.026-.474c.066-.596.253-1.026.474-1.026s.408.43.474 1.026c.596.066 1.026.253 1.026.474s-.43.408-1.026.474",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005095",
    fillRule: "evenodd",
    d: "M0 8h10v7H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4062E",
    fillRule: "evenodd",
    d: "M10 0h11v8H10z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "f15e32f6-abc2-415e-9efd-bb8b8863de94a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgPa;